module.exports = __webpack_public_path__ + "static/img/no-video.0a8e096c.svg";